import React from 'react';

import clsx from 'clsx';

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  View,
  Paper,
  makeStyles,
} from '@gogame/components';
import { DataGridContainer } from '@gogame/data-grid';

import CohortsCell from './CohortsCell';
import CohortsRow from './CohortsRow';
import { TableHighlightProvider, useHighlightContext } from './Highlight';

const useStyles = makeStyles(
  {
    root: {
      flexGrow: 1,
    },
    highlighting: {
      '& td, th': {
        opacity: 0.54,
      },
    },
  },
  { name: 'CohortsTableContainer' }
);

const HighlightingTableContainer = ({ children }) => {
  const { highlighting } = useHighlightContext();
  const classes = useStyles();
  return (
    <TableContainer
      className={clsx(classes.root, {
        [classes.highlighting]: highlighting,
      })}
    >
      {children}
    </TableContainer>
  );
};

const CohortsDataTable = ({
  cohorts,
  toolbar,
  loading,
  fullScreen,
  onToggleFullScreen,
}) => {
  return (
    <DataGridContainer
      fullScreen={fullScreen}
      onToggle={onToggleFullScreen}
      data-cy={'CohortsDataTable'}
      data-cy-role={'grid'}
    >
      <Paper
        variant={'outlined'}
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <TableHighlightProvider>
          {toolbar}
          <View
            loading={loading}
            grow={false}
            style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
          >
            <HighlightingTableContainer>
              <Table>
                <TableHead>
                  {cohorts.cols.map((col, i) => {
                    return (
                      <CohortsCell
                        key={i}
                        align={i ? 'right' : 'left'}
                        borderRight={true}
                      >
                        {col}
                      </CohortsCell>
                    );
                  })}
                </TableHead>
                <TableBody>
                  {cohorts.subHeaderRows?.map(
                    (
                      { data, Actual: actual, 'Total Spend': spent, ...row },
                      i
                    ) => {
                      const regs = Object.values(row)[0];
                      return (
                        <CohortsRow
                          key={i}
                          subHeader={true}
                          subHeaderTitle={i === 0 ? 'Weighted Average' : ''}
                          regs={regs}
                          data={data}
                          dimensionType={cohorts.dimensionType}
                          spent={spent}
                          actual={actual}
                          row={i}
                        />
                      );
                    }
                  )}
                  {cohorts.rows.map(
                    (
                      {
                        'Registration Date': RegDate,
                        data,
                        Actual: actual,
                        'Total Spend': spent,
                        ...row
                      },
                      i
                    ) => {
                      const regs = Object.values(row)[0];
                      return (
                        <CohortsRow
                          key={i}
                          regDate={RegDate}
                          regs={regs}
                          data={data}
                          dimensionType={cohorts.dimensionType}
                          spent={spent}
                          actual={actual}
                          row={i + cohorts.subHeaderRows.length}
                        />
                      );
                    }
                  )}
                </TableBody>
              </Table>
            </HighlightingTableContainer>
          </View>
        </TableHighlightProvider>
      </Paper>
    </DataGridContainer>
  );
};

export default CohortsDataTable;
